import _castArray from 'lodash/castArray';
import _find from 'lodash/find';
import _includes from 'lodash/includes';
import _isFinite from 'lodash/isFinite';
import _join from 'lodash/join';
import _map from 'lodash/map';
import _reduce from 'lodash/reduce';
import _size from 'lodash/size';
import _split from 'lodash/split';
import _takeRight from 'lodash/takeRight';
import _toNumber from 'lodash/toNumber';
// Custom
import { FILTERS_OPERATORS, SORT_DIRECTIONS } from '../constants/App';

/**
* Lists
*/
const paginationSizesList = [
  { value: 20 },
  { value: 50 },
  { value: 100 },
];

/**
* Utils
*/
// Return a string like page,pageSize from pagination object
const serializePagination = (pagination) => `${pagination.page},${pagination.pageSize}`;

// Returns an object with format {page: xxx, pageSize: yyy}
const deserializePagination = (query, pagination, defaultPagination) => {
  // A pagination is defined: return it
  if (pagination) {
    return pagination;
  }
  // Parse query params to build pagination
  if (query && query.pagination) {
    const arr = _split(query.pagination, ',');
    const page = _toNumber(arr[0]);
    const pageSize = _toNumber(arr[1]);
    // Check params are valid
    if (_isFinite(page) && _isFinite(pageSize)) {
      return { page, pageSize };
    }
  }
  return defaultPagination;
};

// Return a string like field1:asc,field2:desc from sort array of objects
const serializeSort = (sort) => _join(_map(sort, ({ field, dir, alias }) => (`${alias || field}:${dir}`)), ',');

// Returns an array of objects with format {field: xxx, dir: asc|desc}
const deserializeSort = (query, sort, defaultSort, columns) => {
  // A sort is defined: return it
  if (sort) {
    return _castArray(sort);
  }
  // Parse query params to build sort
  if (query && query.sort) {
    // Query sort format: field1:asc,field2:desc
    const parsedSort = _reduce(_split(query.sort, ','), (result, querySort) => {
      const arr = _split(querySort, ':');
      let field = arr[0];
      const dir = arr[1];
      // Check params are valid
      if (field && dir && _includes(SORT_DIRECTIONS, dir)) {
        // Check if field is an alias
        const aliasObj = _find(columns, ['alias', field]);
        if (aliasObj) {
          field = aliasObj.field;
        }
        result.push({ field, dir });
      }
      return result;
    }, []);
    // Return sort only if at least one is valid
    if (_size(parsedSort) > 0) {
      return parsedSort;
    }
  }
  if (defaultSort) {
    return _castArray(defaultSort);
  }
  return null;
};

// Return a string like field1:operator1:value1,field2:operator2:value2 from filters array of objects
const serializeFilters = (filters) => _join(_map(filters, ({
  field, operator, value, alias,
}) => (`${alias || field}:${operator}:${value}`)), ',');

// Returns an array of objects with format {field: xxx, operator: yyy, value: zzz}
const deserializeFilters = (query, filters, searchFields) => {
  // Filters are defined: return them
  if (filters) {
    return _castArray(filters);
  }
  // Parse query params to build filters
  if (query && query.filters) {
    // Query filters format: field1:operator1:value1,field2:operator2:value2
    const parsedFilters = _reduce(_split(query.filters, ','), (result, queryFilter) => {
      const arr = _split(queryFilter, ':');
      let field = arr[0];
      const operator = arr[1];
      let value = _join(_takeRight(arr, _size(arr) - 2), ':');
      // Check params are valid
      if (field && operator && value && _includes(FILTERS_OPERATORS, operator)) {
        // Find searchField corresponding
        // Check if an alias is defined
        let searchField = _find(searchFields, ['alias', field]);
        if (!searchField) {
          // No alias => find directly by filter field
          searchField = _find(searchFields, ['filter.field', field]);
        } else {
          // If alias, retrieve field to be used
          field = searchField.filter.field;
        }
        // Transform value is needed
        if (searchField.type.setValueTransform) {
          value = searchField.type.setValueTransform(value);
        }
        // Finaly add the filter to result
        result.push({ field, operator, value });
      }
      return result;
    }, []);
    // Return filters only if at least one is valid
    if (_size(parsedFilters) > 0) {
      return parsedFilters;
    }
  }
  return null;
};

/**
* Model
*/
const listParam = {
  // Lists
  paginationSizesList,

  // Utils
  pagination: {
    serialize: serializePagination,
    deserialize: deserializePagination,
  },
  sort: {
    serialize: serializeSort,
    deserialize: deserializeSort,
  },
  filters: {
    serialize: serializeFilters,
    deserialize: deserializeFilters,
  },
};

module.exports = listParam;



// WEBPACK FOOTER //
// ./models/listParam.js